import { render, staticRenderFns } from "./MaterialsOrderItemRow.vue?vue&type=template&id=2d182baf&scoped=true"
import script from "./MaterialsOrderItemRow.vue?vue&type=script&lang=js"
export * from "./MaterialsOrderItemRow.vue?vue&type=script&lang=js"
import style0 from "./MaterialsOrderItemRow.vue?vue&type=style&index=0&id=2d182baf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d182baf",
  null
  
)

export default component.exports